import { LoadingSpinner } from '@components/ui'

interface LoadingFallbackProps {
  message?: string
}

export function LoadingFallback({ message = 'Loading...' }: LoadingFallbackProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] gap-4">
      <LoadingSpinner size="lg" className="text-sky-500" />
      <p className="text-[var(--color-text-secondary)]">{message}</p>
    </div>
  )
}

export function PageLoadingFallback() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4 bg-[var(--color-bg-primary)]">
      <LoadingSpinner size="lg" className="text-sky-500" />
      <p className="text-[var(--color-text-secondary)]">Loading page...</p>
    </div>
  )
}

export function DashboardSkeleton() {
  return (
    <div className="animate-pulse p-4">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="h-24 bg-[var(--color-surface)] rounded-xl" />
        ))}
      </div>
      <div className="h-[calc(100vh-12rem)] bg-[var(--color-surface)] rounded-xl" />
    </div>
  )
}

export function CardGridSkeleton({ count = 9 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6 animate-pulse">
      {[...Array(count)].map((_, i) => (
        <div key={i} className="h-64 bg-[var(--color-surface)] rounded-xl" />
      ))}
    </div>
  )
}

export function TableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="animate-pulse p-6 space-y-4">
      <div className="h-10 bg-[var(--color-surface)] rounded-lg" />
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="h-16 bg-[var(--color-surface)]/50 rounded-lg" />
      ))}
    </div>
  )
}
